import { getSessionId } from 'shared/lib/session';
import { defaultNormalizedState, normalizeById } from 'shared/lib/normalizer';
import { initialState as profileInitialState, helpers as profileHelpers } from './profile';
import { initialState as jobSearchInitialState } from './jobSearch';
import { AUTH_FORCE_LOGOUT } from './auth';

const BULK_LOAD = 'BULK_LOAD';
const BULK_LOADING = 'BULK_LOADING';
export const BULK_LOADED = 'BULK_LOADED';
export const BULK_LOAD_FAILED = 'BULK_LOAD_FAILED';
const DIALS_LOAD = 'DIALS_LOAD';
const DIALS_LOADING = 'DIALS_LOADING';
const DIALS_LOADED = 'DIALS_LOADED';
export const DIALS_LOAD_FAILED = 'DIALS_LOAD_FAILED';
const RESET_STATE = 'RESET_STATE';

const normalizeBulkParts = ['fields', 'roles', 'languages', 'applications', 'offers'];

export const isGlobalAction = action =>
  [BULK_LOADING, BULK_LOADED, BULK_LOAD_FAILED, DIALS_LOADING, DIALS_LOADED, DIALS_LOAD_FAILED, RESET_STATE, AUTH_FORCE_LOGOUT].includes(action.type);

export const propagateAction = action => [AUTH_FORCE_LOGOUT].includes(action.type);

export default function reducer(state = {}, action) {
  switch (action.type) {
    case BULK_LOADING:
    case DIALS_LOADING:
      return { ...state, app: { appLoading: true } };
    case BULK_LOADED:
    case DIALS_LOADED: {
      const autoNormalized = normalizeBulkParts.reduce((acc, key) => {
        if (action.result[key]) {
          acc[key] = normalizeById(action.result[key]);
        }
        return acc;
      }, {});

      let profile;

      if (action.type === BULK_LOADED) {
        // const applications = normalizeById(action.result.applications);
        // applications.jobIds = action.result.applications.reduce((acc, curr) => {
        //   acc[curr.job.id] = curr.id;
        //   return acc;
        // }, {});
        profile = profileHelpers.normalizeProfile(action.result.profile);
      }

      return {
        ...state,
        ...autoNormalized,
        // applications,
        profile,
        settings: action.result.settings,
        currencies: action.result.currencies,
        favoriteJobs: action.result.favoriteJobs,
        app: { appLoading: false, sessionId: getSessionId() }
      };
    }
    case BULK_LOAD_FAILED:
    case DIALS_LOAD_FAILED:
      return {
        ...state,
        app: {
          appLoading: false,
          sessionId: getSessionId(),
          appLoadingFailed: true,
          error: action.error
        }
      };
    case RESET_STATE:
      return {
        ...state,
        applications: defaultNormalizedState,
        profile: profileInitialState,
        roles: defaultNormalizedState,
        jobSearch: jobSearchInitialState,
      };
    case AUTH_FORCE_LOGOUT:
      return {
        ...state,
        app: {
          ...state.app,
          appLoading: false,
          sessionId: getSessionId()
        }
      };
    default:
      return state;
  }
}

export const actions = {
  bulkLoad() {
    return {
      type: BULK_LOAD,
      types: [BULK_LOADING, BULK_LOADED, BULK_LOAD_FAILED],
      callApi: client => client.get('/user/bulk'),
    };
  },
  dialsLoad() {
    return {
      type: DIALS_LOAD,
      types: [DIALS_LOADING, DIALS_LOADED, DIALS_LOAD_FAILED],
      callApi: client => client.get('/dials/bulk'),
    };
  },
  resetState() {
    return {
      type: RESET_STATE
    };
  },
};
